import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  ClassificationQuery as ClassificationQueryType,
  ClassificationQueryVariables,
} from "./__generated__/ClassificationQuery";

const ClassificationQuery = loader("./ClassificationQuery.gql");

type ClassificationQueryProviderType = (props: {
  children: (data: ClassificationQueryType) => ReactNode;
  variables: ClassificationQueryVariables;
}) => ReactElement;

export const ClassificationQueryProvider: ClassificationQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<ClassificationQueryType, ClassificationQueryVariables>(
    ClassificationQuery,
    {
      variables,
      fetchPolicy: "cache-and-network",
    },
  );

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
